import { attachDataToError, JSONAPIError } from '@applyboard/ui-utils';
import { ZodError } from 'zod';

/**
 * A custom version of zod parse that does the following additional 2 things:
 * 1. If the data is a JSON:API error, it throws a JSONAPIError instead of a ZodError
 * 2. Attaches the data to the error if it is a ZodError, so the error can be
 *    display later using zod-error-viewer
 */
export function parse(schema, data) {
  try {
    return schema.parse(data);
  } catch (err) {
    var jsonApiError = JSONAPIError.fromData(data);
    if (jsonApiError) {
      throw jsonApiError;
    }
    if (err instanceof ZodError) {
      attachDataToError(err, data);
    }
    throw err;
  }
}